<script lang="ts">
    import vm from '@journeys/Journeys.viewmodel';
    import Toolbar from './Toolbar.vue';
    import ToolbarSettings from './ToolbarSettings.vue';
    import SidebarMain from './SidebarMain.vue';
    import PropertyWindow from './PropertyWindow.vue';
    import SendLog from './Menues/SendLog.vue';
    import { useRouter } from 'vue-router';
    import { JourneyStatus } from '@journeys/Enums';

    // this is mostly for debugging, otherwise components are Anonymous
    export default {
        name: 'UI_RootContainer',
    };

    const router = useRouter();
</script>

<script lang="ts" setup>
    const { activeJourney, editor } = vm;

    const getJourneyStatus = (status: number) => {
        switch (status) {
            case JourneyStatus.Draft:
                return 'drafts';
            case JourneyStatus.Active:
                return 'active';
            case JourneyStatus.Ended:
                return 'ended';
            case JourneyStatus.Template:
                return 'templates';
        }
        return 'drafts';
    };

    const openSettingsMenu = () => {
        editor.state.activeMenu = 'settings';
        editor.state.showPropertyWindow = true;
    };
</script>

<template>
    <div class="ui-container">
        <PropertyWindow />

        <div class="journey-title h4">
            <router-link :to="{ name: 'JourneyHome', params: { status: getJourneyStatus(activeJourney.Status) } }">
                {{ $Resources.JourneysLabel }}
            </router-link>
            /
            <span role="button" tabindex="0" @click="openSettingsMenu">
                {{ activeJourney.Title || $Resources.NoTitlePlaceholder }}
                <small class="m-xxs-l">{{ $Resources['JourneyStatus' + JourneyStatus[activeJourney.Status]] }}</small>
            </span>
        </div>

        <Toolbar />

        <ToolbarSettings />

        <SidebarMain />

        <SendLog />

        <!--
        <div class="dev-btm"><h4>{{ editor.dev.bidi?.data }}</h4></div>
        -->
    </div>

    <!-- annoying chrome autofill fix (has to be the last element) -->
    <input style="position: absolute; pointer-events: none; opacity: 0" type="hidden" />
</template>

<style>
    .journey-title {
        position: absolute;
        top: 1rem;
        left: 0.8rem;
        z-index: 10;
        max-width: 600px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        background-color: rgb(247 247 247 / 50%);
        padding: 0.4rem 0.6rem;
        border-radius: var(--border-radius);
        margin: 0;
        line-height: 1.15;
        backdrop-filter: blur(3px);
    }

    .dev-btm {
        display: block;
        position: absolute;
        bottom: 1rem;
        left: 0;
        min-height: 2rem;
        min-width: calc(16rem + 4vw);

        border-radius: 6px;
        background-color: rgba(94, 105, 115, 0.029);
    }

    .dev-btm h4 {
        color: rgb(13, 18, 14);
        font-weight: 600;
    }

    .ui-container {
        z-index: 1;
    }

    .section-group {
        clear: both;
        margin-bottom: 1.2rem;
    }
</style>
